import { render } from "./XTaskItem.vue?vue&type=template&id=7b1afda1&scoped=true"
import script from "./XTaskItem.vue?vue&type=script&lang=js"
export * from "./XTaskItem.vue?vue&type=script&lang=js"

import "./XTaskItem.vue?vue&type=style&index=0&id=7b1afda1&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1afda1"]])

export default __exports__